export default __webpack_public_path__ + "img/a141b559641902dd2ba234cf235ad3cf.svg";